// extracted by mini-css-extract-plugin
export var orderSummary = "_qs-0";
export var showMoreLessButton = "_qs-1";